interface GameTexts {
    [key: string]: string;
}

const InstructionsMixins = {
    methods: {
        getGameInstallInstruction(game: string) : string {
            const gameTexts : GameTexts = {
                'assetto-corsa':
                    `
<p style="margin-bottom: 0.3em; font-weight: 500">Вручную</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Скачайте мод (обычно в формате ZIP или RAR).</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Распакуйте архив с помощью WinRAR или 7-Zip.</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Переместите файлы в соответствующие папки:</p>
<ul>
<li><b>Автомобили:</b> ...\\Steam\\steamapps\\common\\assettocorsa\\content\\cars</li>
<li><b>Трассы:</b> ...\\Steam\\steamapps\\common\\assettocorsa\\content\\tracks</li>
</ul>
<p style="margin-bottom: 0.3em; font-weight: 500">С помощью Content Manager</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Скачайте и установите <a href="https://assettocorsa.club/content-manager.html">Assetto Corsa Content Manager.</a></p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Запустите программу и перейдите в раздел "Моды".</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Нажмите "Импорт" и выберите файл мода.</p>
`,
                'euro-truck-simulator-2': `
<p style="margin-bottom: 0.3em; font-weight: 500">Вручную</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Скачайте мод (обычно в формате ZIP или RAR).</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Распакуйте архив с помощью WinRAR или 7-Zip.</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Переместите файлы (.scs) в папку: <b style="font-weight: 500">Documents/Euro Truck Simulator 2/mod</b></p>
<p style="margin-bottom: 0.3em; font-weight: 500">Активация модов</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Запустите Euro Truck Simulator 2</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Перейдите в "Мод менеджер".</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Активируйте моды, переместив их в правую часть экрана.</p>
                `,

                'beamng-drive': `
<p style="margin-bottom: 0.3em; font-weight: 500">Вручную</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Скачайте мод (обычно в формате ZIP или RAR).</p>
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Откройте папку пользователя:</p>
<ul>
<li>Через программу запуска BeamNG.drive -> Управление папкой пользователя -> Открыть в проводнике</li>
</ul>    
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Создайте папку <b style="font-weight: 500">mods</b> (если она не была создана ранее).</p>    
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Переместите архив в эту папку.</p>      
<p style="margin-bottom: 0.3em">&#8212;&nbsp;Новый мод должен появиться в <b style="font-weight: 500">Диспетчере модификаций</b></p>    
            `
            };

            return gameTexts[game] || 'Текст не найден для этой игры';
        }
    }
}


export default InstructionsMixins